import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Checkbox } from 'antd';
import Client from '../../../models/Client';
import FormMode from '../../../enums/FormMode';
import axios from 'axios';
import ProfilClients from '../ProfilClients'; 
import './ProfilClientsForm.css';
import { API_MEWS_URL }   from '../../../ConfigUrl';

interface IProfilClientsForm {
  mode: FormMode,
  SelectClient: any,
  title: string,
  closeForm: () => void,
  submitLabel: string,
  submitColor: string,
}

function ProfilClientsForm(props: IProfilClientsForm) { 
  const [client, Client] = useState<Array<Client>>([]);
  const Url = API_MEWS_URL;

  useEffect(() => {    
     axios.get(Url + 'ClientType')
      .then(res => Client(res.data));     
  }, [])

  return (
    <div className="FeedbackForm">
      <div className="FeedbackFormTitle">{props.title}</div>
      <div className="FeedbackFormClose" onClick={props.closeForm}>X</div>
      <div className="PrimaryHeader">
        <div className="PrimaryHeaderSeparator"></div>
      </div>       
      <br></br>     
      <div className="">
      {client.map(client => (
              <p><a onClick={() => props.SelectClient(client.name)}>Cliente {client.name}</a></p>
            ))}
      </div>   

      <div className="PrimaryHeader">
        <div className="PrimaryHeaderSeparator"></div>
      </div>     
    </div>
  );
}

export default ProfilClientsForm;
